interface StringTemplateReplacements {
  innerHTML?: string | number;
  numberOfRows?: string | number;
  paginationCurrentPage?: string | number;
  paginationTotalPages?: string | number;
  paginationItemFirst?: string | number;
  paginationItemLast?: string | number;
  sortColumnNumber?: string | number; // sortColumnIndex + 1
  textSortDirection?: string;
  textSortDirectionAscending?: string;
  textSortDirectionDescending?: string;
  thIndex?: string | number;
  columnHeadingText?: string;
}

const stringTemplate = (
  string: string,
  {
    innerHTML = '',
    numberOfRows = '',
    paginationCurrentPage = '',
    paginationTotalPages = '',
    paginationItemFirst = '',
    paginationItemLast = '',
    sortColumnNumber = '',
    textSortDirection = '',
    textSortDirectionAscending = '',
    textSortDirectionDescending = '',
    thIndex = '',
    columnHeadingText = '',
  }: StringTemplateReplacements,
) => {
  if (typeof string === 'undefined') {
    return '';
  }

  let str = string;

  str = str.replace(/{innerHTML}/, innerHTML.toString());
  str = str.replace(/{numberOfRows}/, numberOfRows.toString());
  str = str.replace(
    /{paginationCurrentPage}/,
    paginationCurrentPage.toString(),
  );
  str = str.replace(/{paginationTotalPages}/, paginationTotalPages.toString());
  str = str.replace(/{paginationItemFirst}/, paginationItemFirst.toString());
  str = str.replace(/{paginationItemLast}/, paginationItemLast.toString());
  str = str.replace(/{sortColumnNumber}/, sortColumnNumber.toString());
  str = str.replace(/{textSortDirection}/, textSortDirection);
  str = str.replace(/{textSortDirectionAscending}/, textSortDirectionAscending);
  str = str.replace(
    /{textSortDirectionDescending}/,
    textSortDirectionDescending,
  );
  str = str.replace(/{thIndex}/, thIndex.toString());
  str = str.replace(/{columnHeadingText}/, columnHeadingText);

  return str;
};

export default stringTemplate;
